import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { AbstractAddressComponent } from 'src/app/addresses/address/components/address.abstract.component';
import { ListService, CoreModule, AbpApplicationConfigurationService, CurrentUserDto } from '@abp/ng.core';
import { PageModule } from '@abp/ng.components/page';
import {
  NgbDateAdapter,
  NgbCollapseModule,
  NgbDatepickerModule,
  NgbDropdownModule,
} from '@ng-bootstrap/ng-bootstrap';
import { DateAdapter, ThemeSharedModule } from '@abp/ng.theme.shared';
import { CommercialUiModule } from '@shared/commercial-ui';
import { AddressDetailModalComponent } from 'src/app/addresses/address/components/address-detail.component';
import { AddressViewService } from 'src/app/addresses/address/services/address.service';
import { AddressDetailViewService } from 'src/app/addresses/address/services/address-detail.service';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'app-addresses-tab',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './addresses-tab.component.html',
    styleUrls: ['./addresses-tab.component.scss'],
    imports: [
        NgbCollapseModule,
        NgbDatepickerModule,
        NgbDropdownModule,
        NgSelectModule,
        PageModule,
        CoreModule,
        ThemeSharedModule,
        CommercialUiModule,
        AddressDetailModalComponent,
    ],
    providers: [
        ListService,
        AddressViewService,
        AddressDetailViewService,
        { provide: NgbDateAdapter, useClass: DateAdapter },
    ]
})
export class AddressesTabComponent extends AbstractAddressComponent {
  // A signal, not a plain field: set in a subscribe, which an OnPush ancestor does not redraw
  // for (#42). Replaces the markForCheck() workaround.
  readonly currentUser = signal<CurrentUserDto | undefined>(undefined);

  constructor(
    private appConfigService: AbpApplicationConfigurationService
    ) {
    super();
  }

  ngOnInit(): void {
    this.fetchAddresses(this);
    this.fetchCurrentUser();
  }

  setLoading(loading: boolean) {
    this.isLoading.set(loading);
  }

  refreshAdresses() {
    this.fetchAddresses(this);
  }

  fetchCurrentUser() {
    this.appConfigService.get({ includeLocalizationResources: true }).subscribe({
      next: results => {
        this.currentUser.set(results.currentUser);
      },
    });
  }
}
